<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oLsxWk/images/9781429995269.jpg?1724535954193" alt="This image is the cover for the book Pacific Heights, Marten Fane"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pacific Heights, Marten Fane
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A San Francisco detective becomes entangled with a private intelligence agency as he investigates what appears to be a traceless form of murder</b><br/><br/>A couple meets in a seedy hotel room for an illicit affair, the rules of which are simple: no names, no personal details, the specifics of their lives off-limits. It's all very exciting to Lore Cha—the wife of a successful Silicon Valley entrepreneur—who thinks their forbidden meetings and taboo sexual encounters are exactly the escape she's been looking for: every single detail is as she imagined. But that's the problem. Phillip Krey anticipates every thought before she has it. He plays out her untold fantasies down to the last detail. His insights are beyond intuitive; they're invasive, even frightening. It's as if he has access into her mind. Across town, Elise Currin, wife to one of San Francisco's most powerful businessmen, is also seeing Krey, and is slowly being driven insane by his ability to tap in to her most private desires. When it's revealed that these women are also seeing the same therapist, a chilling scenario unfolds, and the quiet, plotting detective Marten Fane is called in. <br/><br/>Slowly Fane uncovers a plot that goes beyond Krey to reveal a powerful private sector, secret government involvement, and one of the most elaborate and monstrous psychological experiments imaginable: a traceless form of murder.<br/><br/>" … Harper succeeds in sympathetically portraying Elise and Lore as they face genuine danger. " - <i>Publishers Weekly</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Paul Harper
      </h2>
      
      <p class="authorDescription body article"><P><B>Paul Harper</B> is the pseudonym of <B>David Lindsey</B>, the <I>New York Times</I> bestselling author of thirteen previous titles. A native Texan, he lives with his wife in Austin.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Henry Holt and Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0d0cc15e